import * as React from "react";
import classnames from "classnames";

const styles = require('./Spinner.local.css');

export const Spinner = ({ className, ...rest }: React.HTMLProps<HTMLSpanElement>) => (
    <span className={classnames(`glyphicon glyphicon-refresh ${styles.Spinner}`, className)} aria-hidden="true" {...rest} />
);


// WEBPACK FOOTER //
// ./src/components/Spinner/index.tsx